/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   This enum is used to differentiate user types in the overall application.
   Developer: Mohammad Saquib Khan, Created Date: 29-March-2023 
</summary>
*/
enum userTypeEnum{
    SuperAdmin = 0,
    Customer = 1,
    Staff = 2,
    Store = 3,
    Group = 4,
    HeadQuarter = 5,
}

export default userTypeEnum;